module.exports = __webpack_public_path__ + "img/logo.c81e5da3.png";